import { format, parseISO } from "date-fns";
import React from "react";

export const transactionLabel = (
  { date, amount, currency, counterpart },
  session
) => {
  return (
    <div className={"flex gap-3"}>
      <div>{format(parseISO(date), session.account.dateFormat)}</div>
      <div>{(counterpart || "UNKNOWN").slice(0, 10)}</div>
      {amount} {currency}
    </div>
  );
};

export const contactLabel = (contact) => {
  if (!contact) return;

  return (
    <div className={"flex gap-3 items-center"}>
      {[
        contact.company ? `[${contact.company}]` : "",
        contact.firstName,
        contact.lastName,
      ]
        .filter((x) => x?.length)
        .join(" ")}
    </div>
  );
};

export const documentLabel = (entity, session) => {
  if (!entity.label && !entity.date && !entity.amount) {
    return <div>No information</div>;
  }
  return (
    <div className={"flex gap-3"}>
      {contactLabel(entity.contact)}
      <div>
        {entity.type == "charge" ? "-" : "+"}
        {entity.amount} {entity.currency}
      </div>
      <div>
        {entity.date &&
          format(parseISO(entity.date), session.account.dateFormat)}
      </div>
    </div>
  );
};
